export const phoneValidate = (phone) => {
  const re = /^(\+98|0)?9\d{9}$/;
  let res = re.test(phone);
  if (res) {
    return { phone, valid: true };
  } else {
    return { phone, valid: false };
  }
};
